"use client";

import posthog from "posthog-js";
import { useEffect } from "react";
import "./globals.css";
import classNames from "classnames";
import { Comforter_Brush, Noto_Sans, Noto_Serif } from "next/font/google";



const comforterBrush = Comforter_Brush({
  variable: "--font-comforter-brush",
  subsets: ["latin"],
  weight: "400",
  display: "swap",
});

const notoSerif = Noto_Serif({
  variable: "--font-noto-serif",
  weight: ["300", "400", "500", "600", "700"],
  style: ["normal"],
  subsets: ["latin"],
  display: "swap",
});

const notoSans = Noto_Sans({
  variable: "--font-noto-sans",
  weight: ["400", "500", "600", "700", "800", "900"],
  style: ["normal", "italic"],
  subsets: ["latin"],
  display: "swap",
});

// Sits above the root layouts (<html> lives in the route groups), so it must
// render its own <html>/<body>. A plain error.tsx here replaces <html> with a
// <div>, which throws HierarchyRequestError inside the boundary and loops.
export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[global-error.tsx]", {
      url: typeof window !== "undefined" ? window.location.href : undefined,
      digest: error.digest,
      message: error.message,
      stack: error.stack,
      error,
    });
    posthog.captureException(error, { digest: error.digest });
  }, [error]);
  let errorTitle = "Hoppsan - något gick fel!";
  let errorDescr =
    "Vi har för närvarande tekniska problem och arbetar aktivt med att lösa dem så snabbt som möjligt. Vänligen försök igen om en stund.";
  let buttonText = "Tillbaka till startsidan";
  if (error.message === "fetch failed") {
    errorTitle = "Ingen internetanslutning!";
    errorDescr =
      "Det verkar som att du saknar internetuppkoppling. Kontrollera din anslutning och försök igen.";
    buttonText = "Testa igen";
  }

  return (
    <html lang="sv">
      <body
        className={classNames(
          notoSans.variable,
          notoSerif.variable,
          comforterBrush.variable,
          "text-gray-500 bg-sand-500  ",
        )}
      >
        <div className="container py-8 space-y-8">
          <div className="prose">
            <h1>{errorTitle}</h1>
            <p>{errorDescr}</p>
          </div>
          <a className="btn" href="/">
            {buttonText}
          </a>
        </div>
      </body>
    </html>
  );
}
